import Vue from 'vue'
const eventBus = new Vue()

export default {
  EventTypes: {
    pageRefreshed: 'pageRefreshed',
    filesDropped: 'filesDropped',
    panelRecut: 'panelRecut',
    panelLabelPrinted: 'panelLabelPrinted',
    offcutIssueCreated: 'offcutIssueCreated',
    permissionsUpdated: 'permissionsUpdated',
    authSessionUpdated: 'authSessionUpdated',
    userSessionUpdated: 'userSessionUpdated',
    accountUpdated: 'accountUpdated'
  },

  emitEvent(eventType, info = {}) {
    try {
      eventBus.$emit(eventType, info)
    } catch(err) {
      console.error(err)
    }
  },
  on(eventType, func) {
    eventBus.$on(eventType, func)
  },
  off(eventType, func) {
    eventBus.$off(eventType, func)
  }
}